import type { BasicReadingTestPoint } from '@features/calibration/hooks/useCalibrationRuntime/types';

const countDecimals = (value: number): number => {
  // Normalize away binary floating-point noise before counting digits —
  // records seeded before the backend rounded tolerances can carry values
  // like 0.29000000000000004, which would otherwise infer 17 decimals.
  const text = String(Number(value.toPrecision(12)));
  const separatorIndex = text.indexOf('.');
  return separatorIndex === -1 ? 0 : text.length - separatorIndex - 1;
};

export const inferResolution = (point: BasicReadingTestPoint): number =>
  Math.max(countDecimals(point.nominalValue), countDecimals(point.tolerance));

export const calculateError = (
  measured: number | null,
  nominal: number
): number | null => {
  if (measured === null) return null;

  const error = Number((measured - nominal).toFixed(10));
  return Object.is(error, -0) ? 0 : error;
};
